import Battery from './Battery';

export default Battery;
